// extracted by mini-css-extract-plugin
module.exports = {"icon":"RefundHistoryVerificationInProgressState_icon__H02-g","btnIcon":"RefundHistoryVerificationInProgressState_btnIcon__IP6dl"};